import React from 'react';
import { ResponsiveContainer } from 'recharts';
import WaterfallChart from './WaterfallChart';
import NotEnoughDataMessage from './NotEnoughDataMessage';

/**
 * @typedef {object} DeltaPerformanceGraphProps
 * @property {Object} [performanceItem]
 * @property {(dataPoint: { Id: number, Date: string, DeltaIncrease: number, DeltaDecrease: number, Transparent: number, Actual: number | null, Status: number | null, Notes: string | null, ReporterName: string | null }) => void} [dateClick]
 * @property {(event: React.MouseEvent, performanceItem: { MeasurementName: string }) => void} [titleClick]
 * @property {(data: import('recharts').BarRectangleItem, index: number, event: React.MouseEvent<SVGPathElement>) => void} [barClick]
 */

/**
 * @param {DeltaPerformanceGraphProps} props
 */
const DeltaPerformanceGraph = props => {
  const { performanceItem, dateClick, titleClick, barClick } = props;
  const dataPoints = performanceItem.DataPoints;
  const dpCount = dataPoints.length;

  return (
    <div className='delta-report__graph' data-testid='delta-report-graph'>
      <div className='delta-report__graph-name'>
        <span onClick={event => titleClick(event, performanceItem)}>
          {performanceItem.MeasurementName}
        </span>
      </div>
      {performanceItem.IsDiscontinued && (
        <div className='delta-report__expiry'>
          <span> This metric is expiring on {performanceItem.ExpirationDate}</span>
        </div>
      )}

      {dpCount == 0 ? <NotEnoughDataMessage /> : null}

      <ResponsiveContainer width='100%'>
        <WaterfallChart
          height={300}
          data={dataPoints}
          margin={{
            top: 30,
            right: 20,
            left: 20,
            bottom: 20
          }}
          yAxis={performanceItem.Measurement}
          dateClick={dateClick}
          barClick={barClick}
          dpCount={dpCount}
        />
      </ResponsiveContainer>
    </div>
  );
};

export default DeltaPerformanceGraph;
